<template>
  <v-container class="home">

    <filterComponent v-bind:list-genres="listGenres"
                     v-bind:display-map="displayMap"
                     :toggle-display="toggleDisplay"
                     v-on:apply-filters="applyFilters($event)">

    </filterComponent>
    <restaurant-list
      v-if="!displayMap"
      :user-token="userToken"
      v-bind:restaurants="restaurants"
      v-bind:pagination="pagination"
      v-bind:filter="filter"
      v-on:load-restaurant="fetchRestaurants($event)"
    />
    <googleMap
      v-else
      v-bind:restaurants="restaurants"
      v-bind:user-token="userToken"
      :key="mapKey"
    />
  </v-container>
</template>

<script>
import RestaurantList from "../components/Restaurants/RestaurantList";
import RestaurantServices from "../services/restaurant";
import filterComponent from "../components/Filter"
import GoogleMap from "../components/Map";

export default{
  name : "Home",
  components : {
    RestaurantList,
    GoogleMap,
    filterComponent,
  },
  data: () => ({
    displayMap : false,
    mapKey : 0,
    listGenres: [],
    restaurants: [],
    pagination: { page: 1, total: 0 },
    filter: {limit : 20, qword : '',genres : '', priceRangeValue : 0}

  }),

  props:['userToken'],
  async created () {
    await this.fetchRestaurants(0, this.filter)
    this.setGenres()
  },
  methods: {
    fetchRestaurants : async function (currentPage, filter) {
      if (currentPage) {
      this.pagination.page = currentPage;
    }
      if (filter) {
        this.filter = filter;
      }

      const { data } = await RestaurantServices.findRestaurants(this.pagination, this.filter);
      this.restaurants = data.items;
      this.pagination.total = data.total;

    },
    applyFilters: async function(filter) {
      await this.fetchRestaurants(0, filter);
      this.mapKey += 1;
    },

    setGenres: function () {
      let genres = new Set();
      for (const restaurant of this.restaurants) {
        for (const genre of restaurant.genres) {
          genres.add(genre);
        }
      }
      this.listGenres = Array.from(genres);
    },

    toggleDisplay: function() {
      this.mapKey = 0
      this.displayMap = !this.displayMap;
      this.fetchRestaurants(0, this.filters);
    }


  }
}
</script>


<style>
.filter-switch {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
